export function formatNumber(value: number, toFixed: number = 0) {
	const factor = Math.pow(10, toFixed);
	const roundedValue = Math.round(value * factor);
	
	return (roundedValue / factor).toFixed(toFixed);
}

function excelDateSerial(year: number, month: number, day: number) {
	const date = new Date(Date.UTC(year, month - 1, day));
	const excelStartDate = new Date(Date.UTC(1899, 11, 30)); // Excel epoch (!!!)
	const diffInMs = date.getTime() - excelStartDate.getTime();
	return diffInMs / (1000 * 60 * 60 * 24);
}

export function transformData(date: string) {
	const dateArray = date.split("-");
	return excelDateSerial(+dateArray[0], +dateArray[1], +dateArray[2]);
}
